module.exports = __webpack_public_path__ + "assets/img/hzhb1.d798bf21.png";